import axios from "axios";
export const setAxiosHeader = (key:string, value:string)=>{
    if(axios.defaults.headers.common[key])
        delete axios.defaults.headers.common[key];
    axios.defaults.headers.common[key] = value;
    //console.log("setHeader", axios.defaults.headers.common[key])
}